import { useState } from "react";
import GetUserInfoService from "../service/GetUserInfoService";
import useApiStatus from "./useApiStatus";

const useFinantialPassword = ({ onError, onSuccess }) => {
  const { isLoading, setIsLoading, hasError, setHasError } = useApiStatus();
  const [hasFinantialPassword, setHasFinantialPassword] = useState();
  const [isLoadingInitial, setIsLoadingInitial] = useState(true);
  const {
    isLoading: isLoadingCreateFinancialPassword,
    setIsLoading: setIsLoadingCreateFinancialPassword,
    hasError: hasErrorCreateFinancialPassword,
    setHasError: setHasErrorCreateFinancialPassword,
  } = useApiStatus();

  const getUserInfoService = new GetUserInfoService();

  const checkFinantialPassword = async (cancel) => {
    try {
      setIsLoadingInitial(true);
      setIsLoading(true);

      const res = await getUserInfoService.getCheckFinantialPassword(
        localStorage.getItem("__extraconomy_token"),
        localStorage.getItem("__extraconomy_username")
      );
      if (cancel) {
        setIsLoading(false);
        return;
      }
      if (res.messageCode !== 200001) {
        setHasError(true);
        setIsLoadingInitial(false);
        onError(res.messageCode);
        setIsLoading(false);
      } else {
        setHasError(false);
        setIsLoadingInitial(false);
        setHasFinantialPassword(res.result);
        setIsLoading(false);
      }
    } catch (e) {
      setIsLoadingInitial(false);
      setIsLoading(false);
      setHasError(true);
      console.log(e);
    }
  };

  const createFinantialPassword = async (setAsFalse) => {
    try {
      setIsLoadingCreateFinancialPassword(true);

      const res = await getUserInfoService.getCreateFinantialPassword(
        localStorage.getItem("__extraconomy_token"),
        localStorage.getItem("__extraconomy_username")
      );

      if (res.messageCode !== 200001) {
        setHasErrorCreateFinancialPassword(true);
        onError(res.messageCode);
      } else {
        setHasErrorCreateFinancialPassword(false);
        setHasFinantialPassword(res.result);
        onSuccess();
        setAsFalse();
      }
    } catch (e) {
      setHasErrorCreateFinancialPassword(true);
      console.log(e);
    } finally {
      setIsLoadingCreateFinancialPassword(false);
    }
  };

  return {
    isLoading,
    isLoadingCreateFinancialPassword,
    hasFinantialPassword,
    hasError,
    hasErrorCreateFinancialPassword,
    isLoadingInitial,
    createFinantialPassword,
    checkFinantialPassword,
  };
};

export default useFinantialPassword;
